import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled, { css } from "styled-components";
import { minScreenHeight, screenHeight } from "../../../utils";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    ${screenHeight};
    background-color: ${transparentize(0.25, colors.brandDark)};

    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow-y: scroll;

    z-index: 100;
`;

type InnerProps = {
    alignTopOnSmall?: boolean;
    horizontalPadding?: number;
};

export const Inner = styled.div<InnerProps>`
    position: relative;
    transition: 350ms ease all;
    ${minScreenHeight};

    ${props =>
        props.alignTopOnSmall
            ? css`
                  margin: 0;
              `
            : css`
                  margin: auto 0;
                  min-height: auto;
              `}

    padding: 0 ${({ horizontalPadding = 0 }) => horizontalPadding}px;

    ${breakpoints.large} {
        margin: auto 0;
        padding: 32px ${({ horizontalPadding = 0 }) => horizontalPadding}px;
        min-height: auto;
    }
`;

export const Popup = styled.div`
    position: relative;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
`;

export const Close = styled.div`
    background-color: transparent;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    transform: translateY(100%);
    color: ${colors.white};
    z-index: 99999;
`;

type CloseButtonProps = {
    color?: string;
};

export const CloseButton = styled.div<CloseButtonProps>`
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 200ms ease all;
    transform: translateY(-100%);
    ${props =>
        props.color
            ? css`
                  color: ${props.color};
              `
            : css`
                  color: ${colors.white};
              `}
    &:hover {
        cursor: pointer;
    }
`;
